import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";
import {CommonService} from "../service/common";
declare var alertify:any;
declare var $:any;
@Component({
  templateUrl:"./memberNotify.html"
})

export class MemberNotify implements OnInit{

  constructor(
    private router:Router,
    private http:HttpService,
    private common:CommonService
  ){}

  private data:any={
    content:[{
      notityTypeName:'',
      notityStatusName:""
    }]
  };
  public notifyTypeMore=[];
  public notifyStatusMore=[];
  private page={
    pageNumber:1,
    size:10,
    search:'',
    startTime:'',
    endTime:'',
    notityType:'',
    notifyStatus:''
  }
  ngOnInit(): void {
    this.getPath();
    this.initTime();
    this.getNotifyType();
    this.getNotifyStatus();
  }
  private initTime(){
    setTimeout(res=>{
      $("#startTime").datetimepicker({
        language:  'zh-CN',
        format: 'yyyy-mm-dd hh:ii:ss',
        todayBtn:  1,
        autoclose:true,

      }).on('changeDate', function(ev){
        $("#endTime").datetimepicker('setStartDate',$("#startTime").val());
      });

      $("#endTime").datetimepicker({
        language:  'zh-CN',
        format: 'yyyy-mm-dd hh:ii:ss',
        todayBtn:  1,
        autoclose:true,

      }).on('changeDate', function(ev){
        $("#startTime").datetimepicker('setEndDate',$("#endTime").val());
      });
    })

  }

  private imagePath:string='';
  private getPath():void{
    this.http.getData(API.resourcePath)
      .then(res=>{
        this.imagePath=res.data;
        this.getData();
      })
  }

  //获取推送类型
  private getNotifyType():void{
    this.http.getData(API.notifyType).then(res=>{
      this.notifyTypeMore= res.data;
    })
  };
//获取推送状态
  private getNotifyStatus():void{
    this.http.getData(API.notifyStatus).then(res=>{
      this.notifyStatusMore= res.data;
    })
  }



  private getData(){
    let sendData = {
      page:this.page.pageNumber-1,
      size:this.page.size,
      search:this.page.search,
      notityType:this.page.notityType,
      startTime:$("#startTime").val(),
      endTime:$("#endTime").val(),
      notifyStatus:this.page.notifyStatus,
    }

    for (let i in sendData){
      if(sendData[i] === ''){
        delete sendData[i];
      }
    }
    this.http.postData(API.notificationMessage,sendData).then(res=>{
      this.data=res.data;

      for(let i=0;i<this.data.content.length;i++){
        for(let j=0;j<this.notifyTypeMore.length;j++){
          if(this.data.content[i].notifyType == this.notifyTypeMore[j].value){
            this.data.content[i].notityTypeName = this.notifyTypeMore[j].name;
          }
        }
        for(let j=0;j<this.notifyStatusMore.length;j++){
          if(this.data.content[i].notifyStatus == this.notifyStatusMore[j].value){
            this.data.content[i].notityStatusName = this.notifyStatusMore[j].name;
          }
        }
      }
    });
  }

  public search(){
    this.page.pageNumber = 1;
    this.getData();
  }

  private editMemberNotify(id:number){
    this.router.navigate(['index/memberNotify',id]);
  }
  //删除时间值
  private removeStartTime(){
    $('#startTime').val('');
  }
  private removeEndTimeDetil(){
    $('#endTime').val('');
  }


}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/notify/memberNotify.component.ts